import Component from './Component';
import { app } from '../utils/store';

export default class AsyncLoad extends Component {
	constructor({ element }) {
		super({ element })

		this.createObserver()
	}

	createObserver(element) {
		this.observer = new window.IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				this.style = this.element.getAttribute('style')
				
				if(app.device.mobile){ this.element.setAttribute('style', this.element.getAttribute('data-mobile-style')) }
				else { this.element.setAttribute('style', this.style) }

				if (entry.isIntersecting && !this.element.hasAttribute('loaded')) {
					if(app.device.mobile){
						this.element.src = app.webp === true ? this.element.getAttribute('data-mobile-webp') : this.element.getAttribute('data-mobile-src')
					} else {
						this.element.src = app.webp === true ? this.element.getAttribute('data-webp') : this.element.getAttribute('data-src')
					}
					this.element.onload = () => { this.element.setAttribute('loaded', ''); }
				}
			})
		}, {
			// root: window,
			rootMargin: '10%',
		})

		this.observer.observe(this.element)
	}
}
